import { INITIAL_SAVE_REQUEST_META } from '../utils';
import { ChangeEmailWidgetData, ChangeEmailWidgetDisplayMode } from './types';

const defaultChangeEmailWidgetData: NonNullable<ChangeEmailWidgetData['initialData']> = {
  email: '',
  password: '',
};

export const defaultChangeEmailWidgetState: ChangeEmailWidgetData = {
  initialData: defaultChangeEmailWidgetData,
  currentData: defaultChangeEmailWidgetData,
  isDirty: false,
  saveRequest: INITIAL_SAVE_REQUEST_META,
  canUpdateEmail: false,
  displayMode: ChangeEmailWidgetDisplayMode.NotEditing,
};
